export default {
    bindings: {
    },
    controller: 'premierDashboardController',
    template: require('../views/premier.dashboard.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/dashboard/components/premier.dashboard.component.js